import React, { Component, Fragment } from 'react'
import { TIME_OPTIONS } from '../constants'
import { Select } from '@driftt/tide-selects'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'


class DateTimeInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentValue: props.value || null,
      focused: false
    }
  }

  handleDateChange = (date) => {
    this.commitChange(date)
  }

  handleTimeChange = (time) => {
    const [ hours, minutes ] = time.value.split(':')
    const { currentValue } = this.state
    const newValue = moment(currentValue || undefined).hours(hours).minutes(minutes)

    this.commitChange(newValue)
  }

  commitChange = (date) => {
    const { onChange } = this.props
    const newValue = date ? date.valueOf() : null

    this.setState({
      currentValue: newValue
    })
    onChange(newValue)
  }

  render() {
    const { focused, currentValue } = this.state
    const date = currentValue ? moment(currentValue) : null
    const time = date ? date.format('H:mm') : null
    const selectValue = TIME_OPTIONS.filter(({ value }) => value === time)

    return (
      <Fragment>
        <SingleDatePicker
          date={date}
          onDateChange={this.handleDateChange}
          focused={focused}
          onFocusChange={({ focused }) => this.setState({ focused })}
          id="contact-details--typed_inputs-date"
          screenReaderInputMessage="Set a date for this input field"
          placeholder={'Select a date'}
          showClearDate={false}
          anchorDirection="left"
          isOutsideRange={() => {}}
          small={true}
          block={true}
          numberOfMonths={1}
          horizontalMargin={10}
          hideKeyboardShortcutsPanel={true}
        />
        <Select
          className="contact-details--typed_inputs-time"
          placeholder={date ? date.format('hh:mm A') : 'Select time'}
          value={selectValue}
          onChange={this.handleTimeChange}
          options={TIME_OPTIONS}
          clearable={false}
        />
      </Fragment>
    )
  }
}

export default DateTimeInput
